import SubNavBarMobile from './SubNavBarMobile';
import { withRouter } from 'react-router-dom';

export default withRouter(SubNavBarMobile);
